// Logger simples para coletar logs em produção e desenvolvimento
// Armazena em localStorage e imprime no console; fornece utilitários para exportar

const STORAGE_KEY = 'mr_logs';
const DEBUG_CONSOLE_FLAG = 'mr_debug_console';

type LogEntry = {
  ts: number;
  level: 'info' | 'error';
  tag: string;
  data?: any;
};

const read = (): LogEntry[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

const write = (entries: LogEntry[]) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries.slice(-500))); // limita a 500 eventos
  } catch {}
};

const shouldMirrorToConsole = () => {
  if (!import.meta.env.DEV) return false;
  try {
    return localStorage.getItem(DEBUG_CONSOLE_FLAG) === 'true';
  } catch {
    return false;
  }
};

const debugConsole = (level: 'info' | 'error', message: string, data?: any) => {
  if (!shouldMirrorToConsole()) return;
  try {
    if (level === 'error') {
      console.debug(message, data);
      return;
    }
    console.info(message, data);
  } catch {}
};

export const logEvent = (tag: string, data?: any) => {
  const entry: LogEntry = { ts: Date.now(), level: 'info', tag, data };
  const cur = read();
  write([...cur, entry]);
  debugConsole('info', `[LOG] ${tag}`, data);
};

export const logError = (tag: string, data?: any) => {
  const entry: LogEntry = { ts: Date.now(), level: 'error', tag, data };
  const cur = read();
  write([...cur, entry]);
  debugConsole('error', `[ERROR] ${tag}`, data);
};

export const getLogs = (): LogEntry[] => read();
export const clearLogs = () => write([]);

export const downloadLogs = () => {
  const blob = new Blob([JSON.stringify(read(), null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `melhores-retiros-logs-${new Date().toISOString()}.json`;
  a.click();
  URL.revokeObjectURL(url);
};
